import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import Swiper, {Autoplay,Navigation} from "swiper";
import GET_INSTAGRAM from "../class/getInstagram";

const [w, d, mq] = [window, document, window.matchMedia('(max-width: 991px)')];

class blocks {
  constructor(){
    gsap.registerPlugin( ScrollTrigger );
    this.init();
  }

  init (){
    d.documentElement.classList.add('is-dark-mode');
    this.mainvisual();
    this.aboutus();
    this.topics();
    this.tech();
    this.solution();
    this.case();
    $(() => new GET_INSTAGRAM);
  }

  mainvisual() {
    let container = d.querySelectorAll('section.mainvisual');
    let mainImage = new Image();

    if( container.length ){
      mainImage.addEventListener('load', () => container[0].classList.add('is-ready') );
      mainImage.src = '/assets/img/home/mainvisual_img@2x.webp';
    }
  }

  aboutus () {
    gsap.fromTo('.block-aboutus__image .img01', {
      y: '0'
    },{ //アニメーションしたい要素を指定
      y: '40%',
      scrollTrigger: {
        trigger: '.block-aboutus__image',//アニメーションが始まるトリガーとなる要素
        start: 'top bottom', //アニメーションが始まる位置を指定
        end: 'bottom top',
        scrub: true,
        // markers: true,
      }
    });
    gsap.fromTo('.block-aboutus__image .img02', {
      y: '0'
    },{ //アニメーションしたい要素を指定
      y: '-10%',
      scrollTrigger: {
        trigger: '.block-aboutus__image',//アニメーションが始まるトリガーとなる要素
        start: 'top bottom', //アニメーションが始まる位置を指定
        end: 'bottom top',
        scrub: true,
        // markers: true,
      }
    });
  }

  topics () {
    ScrollTrigger.create({
      trigger: '.block-topics-wrap', //アニメーションが始まるトリガーとなる要素
      start: 'top 50%',
      end: 'bottom top',
      toggleClass: {targets: "html", className: "is-light-mode"},
      onToggle: () => {
        d.documentElement.classList.toggle('is-dark-mode')
      }
      // markers: true,
    });
  }
  
  tech () {
    let uav_items = d.querySelectorAll('[data-role="tech-img-btn"]');
    let uav_images = [
      '/assets/img/home/tech_img01@2x.jpg',
      '/assets/img/home/tech_img02@2x.jpg',
      '/assets/img/home/tech_img03@2x.jpg',
      '/assets/img/home/tech_img04@2x.jpg',
      '/assets/img/home/tech_img05@2x.jpg',
    ];
    let stage = d.querySelector('[data-role="tech-img"]');
    let tl = gsap.timeline();
    const replaceImage = obj => {
      tl.clear();
      tl.to(stage, {opacity: 0, duration: 0.3})
      .call(() => {
        stage.src = obj.dataset.src;
      })
      .to(stage, {opacity: 1, duration: 0.3});
    }
    uav_items.forEach( item  => {
      let item_img = new Image();
      item_img.src = item.dataset.src;
      item.addEventListener('mouseover', () => replaceImage(item) );
    });

    w.addEventListener('load', () => ScrollTrigger.create({
      trigger: '.block-tech__head', //アニメーションが始まるトリガーとなる要素
      endTrigger: '.block-tech',
      start: 'top top',
      end: `bottom top+=200px`,
      pin: true,
      // markers: true,
    }));

    ScrollTrigger.create({
      trigger: '.block-tech__uav', //アニメーションが始まるトリガーとなる要素
      start: 'top 15%',
      toggleClass: {targets: ".block-tech__uav-spec", className: "is-active"},
      // markers: true,
      // once: true,
    });
  }

  solution () {
    ScrollTrigger.create({
      trigger: '.block-solution', //アニメーションが始まるトリガーとなる要素
      start: 'top 50%',
      toggleClass: {targets: ".block-solution", className: "is-active"},
      // markers: true,
      once: true,
    });
  }

  case () {
    let caseCarousel = {
      destroy() {}
    };
    let sliderContainer = d.querySelector('[data-plugin="carousel"].swiper');
    let sliderNavigation = d.querySelector('.block-case [data-role="navigation"]');
    let slideCount = d.querySelectorAll('[data-plugin="carousel"] .swiper-slide').length
    const swipeInit = () => {
      if( slideCount <= 1 ) {
        sliderContainer.classList.remove('swiper');
        sliderNavigation.remove();
        return false;
      }
      caseCarousel = new Swiper( sliderContainer, {
        modules: [Autoplay,Navigation],
        autoplay: {
          delay: 3500,
        },
        speed: 700,
        slidesPerView: 'auto',
        spaceBetween: 0,
        grabCursor: true,
        loop: true,
        loopAdditionalSlides: 1,
        navigation: {
          prevEl: '.block-case__navigation-prev',
          nextEl: '.block-case__navigation-next',
        },
      });
    }
    const swipeToggle = is_sp => is_sp? caseCarousel.destroy(false,true): swipeInit();
    swipeToggle(mq.matches);
    mq.addEventListener('change', e => swipeToggle(e.matches) );
  }

}

export default function HOME () {
  d.addEventListener('DOMContentLoaded', () => new blocks );
}